import { Link } from "react-router-dom";
import { Sekcja, Inner, Intro, Lista, Pytanie, CTA } from "./styled";

const questions = [
  {
    question: "Czy warto sprawdzić zdolność kredytową przed znalezieniem nieruchomości?",
    answer: "Tak. Wstępna analiza pomaga ustalić bezpieczny budżet, możliwy wkład własny i listę dokumentów. Dzięki temu łatwiej szukać nieruchomości w odpowiednim przedziale cenowym i rozsądnie ustalić terminy w umowie przedwstępnej.",
  },
  {
    question: "Jak wygląda kredyt na mieszkanie od dewelopera?",
    answer: "Bank ocenia zarówno sytuację kupującego, jak i dokumenty inwestycji. Znaczenie mają między innymi umowa rezerwacyjna lub deweloperska, harmonogram płatności, etap budowy i planowany termin przeniesienia własności. Kredyt może zostać wypłacony jednorazowo albo zgodnie z harmonogramem inwestycji. Przed podpisaniem dokumentów warto ustalić bezpieczny czas na decyzję banku i sprawdzić, jak będą finansowane kolejne płatności.",
  },
  {
    question: "Co sprawdzacie w dokumentach nieruchomości?",
    answer: "Weryfikujemy dokumenty pod kątem wymagań banku oraz ryzyk, które mogą utrudnić finansowanie lub ustanowienie hipoteki. Sprawdzamy między innymi księgę wieczystą, podstawę nabycia, formę własności, obciążenia, dokumenty działki lub budynku oraz terminy i zapisy umowy istotne dla procesu kredytowego. Nie zastępuje to pełnej opinii prawnej. Jeśli sprawa wymaga oceny prawnej, geodezyjnej albo budowlanej, informujemy, z jakim specjalistą warto ją skonsultować.",
  },
  {
    question: "Czy pomagacie również w wyborze ubezpieczenia na życie?",
    answer: "Tak. Najpierw określamy wymagania i potrzeby klienta, a następnie omawiamy zakres ochrony, sumę ubezpieczenia, czas trwania, składkę, karencje i wyłączenia odpowiedzialności. Przy kredycie sprawdzamy również, jak polisa wpływa na warunki banku oraz co stanie się z ochroną po nadpłacie, refinansowaniu lub wcześniejszej spłacie.",
  },
  {
    question: "Ile wkładu własnego potrzeba do kredytu hipotecznego?",
    answer: "Najczęściej banki oczekują 10–20% wartości nieruchomości, ale wymagania zależą od banku, rodzaju nieruchomości i sytuacji klienta. Przy budowie domu wkładem własnym może być również wartość działki oraz część wykonanych prac. Istnieje też Rodzinny Kredyt Mieszkaniowy (RKM), w którym gwarancja BGK może zastąpić brakujący wkład własny — trzeba jednak spełnić warunki programu i wymagania wybranego banku.",
  },
  {
    question: "Czy można złożyć wniosek o kredyt do kilku banków?",
    answer: "Tak. Dobrze dobrane banki zwiększają bezpieczeństwo transakcji, ponieważ mogą inaczej oceniać dochód, nieruchomość i zdolność kredytową. Nie chodzi jednak o wysyłanie wniosków wszędzie, lecz o wybór kilku rozsądnych wariantów.",
  },
  {
    question: "Ile trwa uzyskanie kredytu hipotecznego?",
    answer: "Czas zależy od banku, kompletności dokumentów, formy dochodu i nieruchomości. Dlatego przed podpisaniem umowy rezerwacyjnej lub przedwstępnej warto sprawdzić aktualne czasy procesowe i pozostawić bezpieczny zapas na decyzję oraz uruchomienie kredytu.",
  },
  {
    question: "Czy kredyt na budowę domu działa tak samo jak kredyt na zakup mieszkania?",
    answer: "Nie. Przy budowie bank analizuje między innymi działkę, projekt, pozwolenie, kosztorys i harmonogram. Kredyt jest zwykle wypłacany w transzach, a przed kolejną wypłatą bank może sprawdzać postęp prac.",
  },
  {
    question: "Kiedy warto sprawdzić możliwość przeniesienia kredytu do innego banku?",
    answer: "Gdy obecne oprocentowanie jest wyraźnie wyższe od dostępnych warunków, rata mocno obciąża budżet albo kończy się okres stałego oprocentowania. Porównujemy nie tylko ratę, ale też saldo, pozostały okres, koszty zmiany banku i warunki dodatkowe.",
  },
  {
    question: "Czy lepiej skracać okres kredytu, czy obniżać ratę?",
    answer: "Skracanie okresu najczęściej daje większą oszczędność na odsetkach. Obniżenie raty może natomiast zwiększyć miesięczne bezpieczeństwo budżetu. Najlepszy wariant zależy od Twojego celu, umowy i zasad nadpłat w banku.",
  },
  {
    question: "Czy możemy przeprowadzić cały proces online?",
    answer: "Tak. Obsługujemy klientów z całej Polski. Dokumenty i porównania możemy omawiać zdalnie, a informację o koniecznych wizytach w banku lub u notariusza otrzymasz odpowiednio wcześniej.",
  },
  {
    question: "Czy konsultacje i pomoc w uzyskaniu kredytu są bezpłatne?",
    answer: "Tak. Konsultacje i nasza obsługa nie wiążą się dla klienta z dodatkową opłatą. Wynagrodzenie otrzymujemy od banku po uruchomieniu kredytu. Przedstawiane warunki są warunkami banku — nie doliczamy własnego narzutu do oprocentowania, prowizji bankowej ani raty, dlatego sama obsługa przez Serce Finansów nie pogarsza przedstawionej oferty kredytu.",
  },
];

const FAQ = () => (
  <Sekcja id="faq">
    <Inner>
      <Intro>
        <span>Najczęstsze pytania</span>
        <h2>Krótko i konkretnie o kredycie</h2>
        <p>Każda sytuacja jest inna, ale te pytania pojawiają się podczas pierwszych rozmów najczęściej.</p>
      </Intro>
      <Lista>
        {questions.map(({ question, answer }) => (
          <Pytanie key={question}>
            <summary>{question}<span aria-hidden="true">+</span></summary>
            <p>{answer}</p>
          </Pytanie>
        ))}
      </Lista>
      <CTA>
        <div><strong>Nie widzisz swojego pytania?</strong><span>Opisz krótko sytuację. Wskażemy dobry pierwszy krok.</span></div>
        <Link to="/" data-contact-cta onClick={() => window.setTimeout(() => document.getElementById("formularz")?.scrollIntoView({ behavior: "smooth" }), 80)}>Zapytaj nas →</Link>
      </CTA>
    </Inner>
  </Sekcja>
);

export default FAQ;

